/**
 * Run `task` once the page has stopped downloading (nothing new for
 * `quietMs`), or after `longestWaitMs` at the latest, so background work never
 * competes with what the user is waiting for. Returns a cancel function.
 */
export const whenNetworkQuiet = (
  task: () => void,
  quietMs = 1500,
  longestWaitMs = 8000,
): (() => void) => {
  let timer = 0;
  let observer: PerformanceObserver | undefined;
  const run = () => {
    stop();
    task();
  };
  const deadline = window.setTimeout(run, longestWaitMs);
  const stop = () => {
    window.clearTimeout(timer);
    window.clearTimeout(deadline);
    observer?.disconnect();
  };
  const restart = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, quietMs);
  };
  try {
    observer = new PerformanceObserver(restart);
    observer.observe({ type: 'resource' });
  } catch {
    // No resource timing here: the plain delay still applies.
  }
  restart();
  return stop;
};
